export const getWindowLocation = (
  type: "href" | "origin" | "pathname" = "href",
): string => {
  if (typeof window === "undefined") return "";

  switch (type) {
    case "origin":
      return window.location.origin;
    case "pathname":
      return window.location.pathname;
    default:
      return window.location.href;
  }
};
